import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Buffer } from "buffer";
import { validateGuid } from "../services/apiService";
import ContractPreviewPDF from "../components/ContractPreviewPDF";
import Button from "../components/Button";
import Container from "../components/Container";
import Content from "../components/Content";
import { Row, Card, Col, FormCheck } from "react-bootstrap";
import Label from "../components/Label";
import { getHeadersAPI } from "../api/ServicesConfiguration";

function ContractPreview() {
  const navigate = useNavigate();

  //Get URL Parameters
  const queryParameters = new URLSearchParams(window.location.search);
  const guid = queryParameters.get("guid");
  const smartDocumentContractId = queryParameters.get(
    "smartDocumentContractId"
  );

  if (!guid) {
    navigate("/ErrorPage");
  }

  //variables
  const [contractDocument, setContractDocument] = useState<any>();
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingFile, setIsLoadingFile] = useState(true);

  const [marktingOptin, setMarktingOptin] = useState({
    Email: false,
    Phone: false,
    SMS: false,
    Post: false,
    No: true,
  });

  // FetchData
  const fetchData = async () => {
    if (!(await validateGuid(guid!))) {
      navigate("/ErrorPage");
    }

    try {
      const responseMarkting: any = await axios.get(
        process.env.REACT_APP_BASE_API_URL + "/marktingOptin/" + guid,
        {
          headers: await getHeadersAPI()
        }
      );

      if (responseMarkting.data) {
        setMarktingOptin(responseMarkting.data);

        setMarktingOptin({
          Email: responseMarkting.data.Email,
          Phone: responseMarkting.data.Phone,
          SMS: responseMarkting.data.SMS,
          Post: responseMarkting.data.Post,
          No: !(
            responseMarkting.data.Email ||
            responseMarkting.data.Phone ||
            responseMarkting.data.SMS ||
            responseMarkting.data.Post
          ),
        });
      }

      const response: any = await axios.get(
        process.env.REACT_APP_BASE_API_URL +
          "/getContract/" +
          smartDocumentContractId,
        {
          headers: await getHeadersAPI()
        }
      );

      if (response.data) {
        const binary = response.data[0].Binary.data;
        const base64 = Buffer.from(binary).toString("base64");
        setContractDocument(base64);
        setIsLoadingFile(false);
      } else {
        navigate("/ErrorPage");
      }
    } catch (error) {
      navigate("/ErrorPage");
    }
  };

  //Run 1 time
  useEffect(() => {
    if (!guid) {
      navigate("/ErrorPage");
    } else {
      setIsLoadingFile(true);
      fetchData();
    }
  }, []);

  //Sign contract
  async function signOnClick() {
    setIsLoading(true);
    let link: any;
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_API_URL}/signContract/${guid}/${smartDocumentContractId}`,
        { marktingOptin },
        { headers: await getHeadersAPI() }
      );

      link = response.data;
    } catch (error) {
      alert(error);
      setIsLoading(false);
    }

    setIsLoading(false);
    window.location.href = link;
  }

  //Download contract and send manual contract
  async function handlerDownloadOnClick() {
    setIsLoading(true);

    setIsLoading(false);
  }

  function backOnClick() {
    navigate(-1);
  }

  function marktingOptionsOnChange(input: any, value: any) {
    if (input == "No") {
      if (value) {
        setMarktingOptin((prevState: any) => ({
          ...prevState,
          Email: false,
          Phone: false,
          SMS: false,
          Post: false,
          No: true,
        }));
      }
    }
    if (input == "Email") {
      setMarktingOptin((prevState: any) => ({
        ...prevState,
        Email: value,
        No: false,
      }));
    }
    if (input == "Phone") {
      setMarktingOptin((prevState: any) => ({
        ...prevState,
        Phone: value,
        No: false,
      }));
    }
    if (input == "SMS") {
      setMarktingOptin((prevState: any) => ({
        ...prevState,
        SMS: value,
        No: false,
      }));
    }
    if (input == "Post") {
      setMarktingOptin((prevState: any) => ({
        ...prevState,
        Post: value,
        No: false,
      }));
    }
  }

  return (
    <div>
      <Content className="mt-5">
        <Container>
          <Card className="p-5">
            <div style={{ textAlign: "center" }}>
              <div className="mb-4" style={{ fontSize: 30, fontWeight: 700 }}>
                Lees & onderteken de contract
              </div>
              <div className="mb-4">
                Scroll naar beneden als u het contract wilt downloaden. Klik op
                ‘Onderteken’ om het contract via iDIN direct te ondertekenen.
              </div>
              <div className="mb-4">
                {!isLoadingFile && (
                  <ContractPreviewPDF binary={contractDocument} pdf={true} />
                )}
              </div>
              <div style={{ fontSize: 10 }}>
                <p>Toestemming voor marketingdoeleinden.</p>
                <p>
                  Geef hieronder aan of uw persoonlijke gegevens mogen worden gebruikt voor marketingdoeleinden. U kunt deze toestemming altijd intrekken, herzien of wijzigen door een e-mail te sturen aan: <a href="mailto:privacy@santanderleasing.nl" style={{ color: "red" }}>privacy@santanderleasing.nl</a>. Lees op 
                  <a href="https://www.santanderleasing.nl/privacy-verklaring/" style={{ color: "red" }}> https://www.santanderleasing.nl/privacy-verklaring/</a> ons privacybeleid over hoe wij uw persoonlijke gegevens verwerken.
                </p>
                <p>
                Ja, ik geef toestemming voor het ontvangen van marketingcommunicatie (inclusief promotionele aanbiedingen, productinformatie en updates):
                </p>
              </div>

              <Row
                style={{
                  justifyContent: "center",
                  fontSize: 10,
                  marginBottom: 10,
                }}
              >
                <FormCheck
                  label={"Ja, e-mail"}
                  checked={marktingOptin.Email}
                  // onChange={() =>
                  //   setMarktingOptin((prevState: any) => ({
                  //     ...prevState,
                  //     Email: !marktingOptin.Email,
                  //   }))
                  // }
                  onChange={() =>
                    marktingOptionsOnChange("Email", !marktingOptin.Email)
                  }
                />
                <FormCheck
                  label={"Ja, telefoon"}
                  checked={marktingOptin.Phone}
                  // onChange={() =>
                  //   setMarktingOptin((prevState: any) => ({
                  //     ...prevState,
                  //     Phone: !marktingOptin.Phone,
                  //   }))
                  // }
                  onChange={() =>
                    marktingOptionsOnChange("Phone", !marktingOptin.Phone)
                  }
                />
                <FormCheck
                  label={"Ja, SMS"}
                  checked={marktingOptin.SMS}
                  // onChange={() =>
                  //   setMarktingOptin((prevState: any) => ({
                  //     ...prevState,
                  //     SMS: !marktingOptin.SMS,
                  //   }))
                  // }
                  onChange={() =>
                    marktingOptionsOnChange("SMS", !marktingOptin.SMS)
                  }
                />
                <FormCheck
                  label={"Ja, brief"}
                  checked={marktingOptin.Post}
                  // onChange={() =>
                  //   setMarktingOptin((prevState: any) => ({
                  //     ...prevState,
                  //     Post: !marktingOptin.Post,
                  //   }))
                  // }
                  onChange={() =>
                    marktingOptionsOnChange("Post", !marktingOptin.Post)
                  }
                />
                <FormCheck
                  label={"Nee"}
                  checked={marktingOptin.No}
                  onChange={() =>
                    marktingOptionsOnChange("No", !marktingOptin.No)
                  }
                />
              </Row>
              {!isLoadingFile && (
                <div className="mb-3">
                  <a
                    download="Contract"
                    href={"data:application/pdf;base64," + contractDocument}
                    onClick={handlerDownloadOnClick}
                  >
                    Download
                  </a>
                </div>
              )}

              <Row>
                <div className="col-lg-12 ">
                  <Button
                    className="btn btn-back float-left"
                    onClick={backOnClick}
                    isLoading={isLoading}
                  >
                    Vorige
                  </Button>
                  <Button
                    className="btn-main-color float-right"
                    onClick={signOnClick}
                    isLoading={isLoading}
                  >
                    Bevestigen
                  </Button>
                </div>
              </Row>
            </div>
          </Card>
        </Container>
      </Content>
    </div>
  );
}

export default ContractPreview;
